/* Countdown timers for the payment session and the unauthorized screen.
 *
 * Session expiry uses remaining TTL aligned to engine server_time when available,
 * then counts down with performance.now() (monotonic) — so a wrong or changing
 * customer device clock cannot force Session Timeout while the JWT is still valid.
 */
import jwt_decode from "jwt-decode";

export default {
  methods: {

    //no need token
    showRemaining(total) {
      var t = new Date();
      var getMin = t.getMinutes();
      var getSec = t.getSeconds();
      var getMiliSec = t.getMilliseconds();

      const timer = setInterval(() => {
        const now = new Date();
        var getYear = now.getFullYear();
        var getMonth = now.getMonth();
        var getDate = now.getDate();
        var getHour = now.getHours();

        const end = new Date(
          getYear,
          getMonth,
          getDate,
          getHour,
          getMin + total,
          getSec,
          getMiliSec
        );
        const distance = end.getTime() - now.getTime();
        if (distance < 0) {
          this.dispaly_time_otp = false;
          this.display_resend_otp_text = true;
          clearInterval(timer);
          return;
        }
        const minutes = Math.floor((distance % this._hours) / this._mintues);
        const seconds = Math.floor((distance % this._mintues) / this._seconds);

        this.display_min = minutes < 10 ? "0" + minutes : minutes;
        this.display_sec = seconds < 10 ? "0" + seconds : seconds;
      }, 1000);
    },

    //no need token — monotonic countdown (immune to device clock changes)
    UnauthorizedTimeRemaining(timeInMinutes) {
      const remainingMs = timeInMinutes * 60 * 1000;
      const tickStarted = performance.now();

      const timer = setInterval(() => {
        const distance = remainingMs - (performance.now() - tickStarted);
        if (distance < 0) {
          this.isMainDiv = false;
          this.isUnauthorized = true;
          this.isMaintenanceMode = false;
          this.is_bisc_display = false;
          clearInterval(timer);
          return;
        }
      }, 1000);
    },

    /**
     * Normalize engine server_time to milliseconds.
     * Accepts Unix seconds (preferred) or milliseconds.
     */
    parseServerTimeMs(serverTime) {
      if (serverTime === null || typeof serverTime === "undefined" || serverTime === "") {
        return null;
      }
      const n = Number(serverTime);
      if (!Number.isFinite(n) || n <= 0) {
        return null;
      }
      // Unix seconds are ~1e9; ms are ~1e12
      return n < 1e12 ? n * 1000 : n;
    },

    /**
     * Countdown from merchant JWT exp (JWT_TTL in engine .env).
     * Pass server_time from check-token so remaining matches engine, not device clock.
     * Tick uses performance.now() after remaining is computed once (monotonic).
     */
    startSessionTimer(decodedToken, serverTime) {
      this.clearSessionTimer();

      let decoded = decodedToken;
      if ((!decoded || !decoded.exp) && this.sp_token) {
        try {
          decoded = jwt_decode(this.sp_token);
        } catch (e) {
          decoded = null;
        }
      }

      const expSec = decoded && decoded.exp ? Number(decoded.exp) : NaN;
      const iatSec = decoded && decoded.iat ? Number(decoded.iat) : NaN;
      if (!Number.isFinite(expSec)) {
        this.UnauthorizedTimeRemaining(15);
        return;
      }

      const expireAtMs = expSec * 1000;
      const serverTimeMs = this.parseServerTimeMs(serverTime);
      let remainingMs;

      if (serverTimeMs !== null) {
        // True remaining vs engine wall clock (skew-safe)
        remainingMs = expireAtMs - serverTimeMs;
      } else if (Number.isFinite(iatSec)) {
        // Older engines: full JWT TTL from page open (skew-safe)
        remainingMs = (expSec - iatSec) * 1000;
      } else {
        remainingMs = expireAtMs - Date.now();
      }

      if (remainingMs <= 0) {
        this.session_display_time = "00:00";
        this.sessionUrgent = true;
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
        this.is_bisc_display = false;
        return;
      }

      // Monotonic countdown: immune to mid-session device clock changes
      this._sessionRemainingMs = remainingMs;
      this._sessionTickStarted = performance.now();
      this.showSessionTimer = true;
      this.tickSessionTimer();
      this.sessionTimerInterval = setInterval(() => {
        this.tickSessionTimer();
      }, 1000);
    },

    tickSessionTimer() {
      const distance =
        this._sessionRemainingMs - (performance.now() - this._sessionTickStarted);
      if (distance <= 0) {
        this.session_display_time = "00:00";
        this.sessionUrgent = true;
        this.clearSessionTimer();
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
        this.is_bisc_display = false;
        return;
      }

      const totalSec = Math.floor(distance / 1000);
      const hours = Math.floor(totalSec / 3600);
      const minutes = Math.floor((totalSec % 3600) / 60);
      const seconds = totalSec % 60;
      const pad = (n) => (n < 10 ? "0" + n : String(n));

      this.session_display_time =
        hours > 0
          ? hours + ":" + pad(minutes) + ":" + pad(seconds)
          : pad(minutes) + ":" + pad(seconds);
      this.sessionUrgent = totalSec <= 60;
    },

    clearSessionTimer() {
      if (this.sessionTimerInterval) {
        clearInterval(this.sessionTimerInterval);
        this.sessionTimerInterval = null;
      }
    },
  },
};
